import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PcsMerchantSchema = withDefaults({
  type: 'pcs-merchant',
  fields: [
    {
      kind: 'attribute',
      name: 'entityType',
    },
    {
      kind: 'attribute',
      name: 'entityId',
    },
    {
      kind: 'attribute',
      name: 'locationNames',
    },
    {
      kind: 'attribute',
      name: 'policy',
    },
    {
      // Owning company. Null for a "global" merchant — the transitional
      // fee-disambiguation shape a company-scoped merchant takes precedence over.
      kind: 'belongsTo',
      name: 'pcsCompany',
      type: 'pcs-company',
      options: {
        async: false,
        inverse: 'pcsMerchants',
      },
    },
    {
      kind: 'hasMany',
      name: 'pcsMerchantNetworkMerchants',
      type: 'pcs-merchant-network-merchant',
      options: {
        async: false,
        inverse: 'pcsMerchant',
      },
    },
    {
      kind: 'hasMany',
      name: 'pcsNetworkMerchants',
      type: 'pcs-network-merchant',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default PcsMerchantSchema;
